import { Link } from "react-router-dom";

export function Logo({ className = "", variant = "full", light = false, height = 40 }) {
  let src = "/logo.png";
  if (variant === "wordmark") {
    src = light ? "/logo-wordmark-light.png" : "/logo-wordmark.png";
  }
  return (
    <Link to="/" data-testid="logo-link" className={`inline-flex items-center ${className}`}>
      <img
        src={src}
        alt="Yayra Glover Organic Inputs"
        style={{ height }}
        className="w-auto object-contain"
      />
    </Link>
  );
}
